import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'

import s from './styles.module.scss'

type Props = {
  onShowForm?: () => void
  isDifficultRoute?: boolean
  firstSegment: DifficultRoute
  lastSegment?: DifficultRoute
  textDirection?: string
}

export const SearchParams = ({
  onShowForm,
  isDifficultRoute,
  firstSegment,
  lastSegment,
  textDirection,
}: Props) => {
  return (
    <div
      className={s.content}
      onClick={onShowForm}
    >
      {isDifficultRoute ? (
        <div className={s.left}>
          <div
            className={s.direction}
          >{`${firstSegment.from?.cityName} –– ${lastSegment?.to?.cityName}`}</div>

          <div className={s.info}>{textDirection}</div>
        </div>
      ) : (
        <div className={s.left}>
          <div
            className={s.direction}
          >{`${firstSegment.from?.cityName || firstSegment.from?.cityIataCode} –– ${firstSegment.to?.cityName || firstSegment.to?.cityIataCode}`}</div>

          <div className={s.info}>{textDirection}</div>
        </div>
      )}

      <AppIcon
        className={s.loop}
        id={AllIcons.LOOP}
      />
    </div>
  )
}
